import { createContext } from 'react'

export type FeatureFlag = {
  name: string
  enabled: boolean
  requiredSubscriptions?: string[]
}

export type FeatureFlagsContextType = {
  featureFlags: readonly FeatureFlag[]
}

export const FeatureFlagsContext =
  createContext<FeatureFlagsContextType | null>(null)
